// src/module.ts
function interopDefault(module) {
  return module.default || module;
}

export {
  interopDefault
};
//# sourceMappingURL=chunk-APJY76CK.mjs.map